import { CreateSpeaker, PaginatedSpeakers, Speaker } from '@/types/speakers.types';
import { Get, Post, Put } from '../helpers';

export const SPEAKERS_PAGE_SIZE = 50;

const toSpeakerArray = (data: unknown): Speaker[] =>
  Array.isArray(data) ? data : ((data as PaginatedSpeakers)?.results ?? []);

export const FetchSpeakersPage = async ({
  channel,
  page = 1,
  limit = SPEAKERS_PAGE_SIZE,
  search,
  signal,
}: {
  channel: number;
  page?: number;
  limit?: number;
  search?: string;
  signal?: AbortSignal;
}): Promise<PaginatedSpeakers> => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  if (search) {
    params.append('search', search);
  }

  return Get({
    path: `/v3/admin/events/speakers/${channel}?${params.toString()}`,
    signal,
  });
};

export const FetchSpeakersByIds = async ({
  channel,
  speakerIds,
  signal,
}: {
  channel: number;
  speakerIds: number[];
  signal?: AbortSignal;
}): Promise<Speaker[]> => {
  if (!speakerIds.length) return [];

  const params = new URLSearchParams({ ids: speakerIds.join(',') });

  return Get({
    path: `/v3/admin/events/speakers/${channel}?${params.toString()}`,
    signal,
  }).then(toSpeakerArray);
};

export const InsertSpeaker = async (
  baseLanguage: string,
  languages: string[],
  speaker: CreateSpeaker
): Promise<Speaker> => {
  return Post({
    path: '/v3/admin/events/speakers',
    body: {
      baseLanguage: baseLanguage,
      languages: languages,
      speaker: speaker,
    },
  });
};

export const UpdateSpeaker = async ({
  baseLanguage,
  languages,
  speaker,
}: {
  baseLanguage: string;
  languages: string[];
  speaker: Speaker;
}): Promise<Speaker> => {
  return Put({
    path: '/v3/admin/events/speakers',
    body: {
      baseLanguage,
      languages,
      speaker,
    },
  });
};
